import { ReactNode } from 'react';
import { AuditDataDto } from 'services/api/api-client';
import { BrightTooltip } from 'components/tooltips/BrightTooltip.tsx';
import { DocumentNameTooltipTitle } from '../../tooltips/DocumentNameTooltipTitle.tsx';
import styles from '../DocumentListItem.module.scss';

type TreeItemNameProps = {
  name: string;
  auditData: AuditDataDto | null;
  showTooltip: boolean;
  children: ReactNode;
};

/** Displays the name of a tree item with an optional tooltip showing audit data. */
export const TreeItemName = ({
  name,
  auditData,
  showTooltip,
  children,
}: TreeItemNameProps) => (
  <BrightTooltip
    title={<DocumentNameTooltipTitle name={name} auditData={auditData} />}
    enterDelay={300}
    placement={'top-start'}
    disableHoverListener={!showTooltip}
  >
    <div className={styles.treeItemName}>{children}</div>
  </BrightTooltip>
);
